export default {
  props: {
    modelValue: {
      default: null
    },
    helperText: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    touched: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    }
  },

  watch: {
    inputValue: function(value) {
      if (!this.disabled) {
        this.$emit('update:modelValue', value);
      }
    },
    value: function(value) {
      this.inputValue = value;
    },
  },

  mounted() {
    if(this.value) {
      this.inputValue = this.value;
    }
    if (this.touched) {
      this.pristine = false;
    }
  },

  data() {
    return {
      inputValue: null,
      focused: false,
    }
  },

  computed: {
    labelOrPlaceholder() {
      return this.focused || !this.pristine ? this.placeholder : null;
    }
  },

  methods: {
    handleClickOnWrapper() {
      this.focused = true;
      this.$refs.field.focus();
    },
    handleClickOutsideWrapper() {
      this.focused = false;
    }
  }
}